// // src/App.js
// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Header from './components/Header';
// import Footer from './components/Footer';
// import Home from './pages/Home';
// import About from './pages/About';
// import Contact from './pages/Contact';
// import PrivacyPolicy from './pages/PrivacyPolicy';
// import TermsAndConditions from './pages/TermsAndConditions';
// import Disclaimer from './pages/Disclaimer';
// import CSRPolicy from './pages/CSRPolicy';
// import AntiFraudPolicy from './pages/AntiFraudPolicy';
// import ProcessBack from './pages/ProcessBack';

// function App() {
//   return (
//     <Router>
//       <Header />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/contact" element={<Contact />} />
//         {/* New Pages */}
//         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//         <Route path="/term-and-condition" element={<TermsAndConditions />} />
//         <Route path="/disclaimer" element={<Disclaimer />} />
//         <Route path="/csr-policy" element={<CSRPolicy />} />
//         <Route path="/BCIBL-Anti-Fraud-Policy" element={<AntiFraudPolicy />} />
//         <Route path="/ProcessBack" element={<ProcessBack />} />
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//       <Footer />
//     </Router>
//   );
// }

// export default App;








// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import Disclaimer from './pages/Disclaimer';
import CSRPolicy from './pages/CSRPolicy';
import AntiFraudPolicy from './pages/AntiFraudPolicy';
import ProcessBack from './pages/ProcessBack';

/* Layout Wrapper */
function AppLayout() {
  const location = useLocation();

  // Routes where Header/Footer should be hidden
 const isProcessBackPage = location.pathname === "/ProcessBack";

  return (
    <>
      {/* Header */}
       <Header hideLogin={isProcessBackPage} />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        {/* New Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/term-and-condition" element={<TermsAndConditions />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/csr-policy" element={<CSRPolicy />} />
        <Route path="/BCIBL-Anti-Fraud-Policy" element={<AntiFraudPolicy />} />

        {/* SSO Processing Page */}
        <Route path="/ProcessBack" element={<ProcessBack />} />

        {/* Redirect unknown routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Footer */}
       <Footer />
    </>
  );
}

/* Main App */
function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
